import React from 'react';
import ReactQuill, { Quill } from "react-quill";
import { RangeStatic, Sources } from "quill";
import { ImageUpload } from '../../lib/imageUpload';
import firebase from 'firebase';

Quill.register("modules/imageUpload", ImageUpload);

interface IEditorProps {
  value?: string;
  nodeId: string;
  onFocus?: (range: RangeStatic, source: Sources, editor: any) => void;
  onBlur?: (previousRange: RangeStatic, source: Sources, editor: any) => void;
  onChange: (value: string) => any;
}

export default class Editor extends React.Component<IEditorProps> {
  QUILL_MODULES = {
    syntax: false,
    toolbar: [
      { header: 2 },
      "bold",
      "italic",
      "underline",
      "strike",
      { list: "ordered" },
      { list: "bullet" },
      "link",
      "image",
      "code-block"
    ],
    imageUpload: {
      customUploader: (file: File, callback: (url: any) => void) => {
        const storageRef = firebase.storage().ref();
        const metadata = {
          contentType: file.type
        };
        const uploadTask = storageRef
          .child("images/node-" + this.props.nodeId + "/" + file.name)
          .put(file, metadata);

        uploadTask.on("state_changed", null, null, () => {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            console.log("File available at", downloadURL);
            callback(downloadURL);
          });
        });
      }
    }
  };

  render() {
    const { value, onFocus, onBlur, onChange } = this.props;

    return (
      <ReactQuill
        modules={this.QUILL_MODULES}
        value={value || ""}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(_a, _b, _c, editor) => {
          onChange(editor.getHTML());
        }}
      />
    );
  }
}